<script>
  import {setContext, tick} from 'svelte';
  import {writable} from 'svelte/store';
  import {fade} from 'svelte/transition';

  export let maxDrawerWidth = 320;
  export let drawerWidth = Math.min(window.innerWidth * 0.8, maxDrawerWidth);
  export let maxWidth = 600; // drawer will be shown always if container width is bigger than maxWidth

  let containerWidth = window.innerWidth;

  // read-only
  export let isStatic = containerWidth > maxWidth;

  let drawerTranslateLeft = 0; // 0 ~ 1
  const isDrawerOpened = writable(false);
  const isDrawerStatic = writable(isStatic);

  setContext('isDrawerOpened', isDrawerOpened);
  setContext('isDrawerStatic', isDrawerStatic);


  $: {
    isDrawerOpened.set(drawerTranslateLeft > 0);
    isStatic = containerWidth > maxWidth;
    isDrawerStatic.set(isStatic);
  }


  let onMouseUp;
  let onMouseMove;
  let drawerTransition = true;

  let isDrawerOpenedBeforeMouseDown = false;


  const mouseUpHandler = async () => {
    drawerTransition = true;
    await tick();

    onMouseMove = null;
    onMouseUp = null;
  };

  const open = async () => {
    await mouseUpHandler();
    drawerTranslateLeft = 1;
  };

  const close = async () => {
    await mouseUpHandler();
    drawerTranslateLeft = 0;
  };

  const toggleDrawer = () => {
    if ($isDrawerOpened) {
      return close();
    } else {
      return open();
    }
  };

  setContext('openDrawer', open);
  setContext('closeDrawer', close);
  setContext('toggleDrawer', toggleDrawer);

  const onMouseDown = e => {
    if (!$isDrawerOpened && e.touches[0].clientX > drawerWidth / 10) return;
    if ($isDrawerOpened && e.touches[0].clientX < drawerTranslateLeft * drawerWidth * 0.9) return;
    isDrawerOpenedBeforeMouseDown = drawerTranslateLeft !== 0;

    drawerTranslateLeft = Math.min(e.touches[0].clientX / drawerWidth, 1);

    onMouseMove = e => {
      drawerTransition = false;
      drawerTranslateLeft = Math.min(e.touches[0].clientX / drawerWidth, 1);
    };
    onMouseUp = async () => {
      await mouseUpHandler();

      if (isDrawerOpenedBeforeMouseDown) {
        drawerTranslateLeft = drawerTranslateLeft < 0.8 ? 0 : 1;
      } else {
        drawerTranslateLeft = drawerTranslateLeft < 0.2 ? 0 : 1;
      }
    };
  };

</script>
<svelte:window on:touchmove={onMouseMove} on:touchend={onMouseUp} on:touchcancel={onMouseUp}/>
<div class="container" on:touchstart={onMouseDown} bind:clientWidth={containerWidth} class:static={$isDrawerStatic}>
  <div class="content">
    <slot name="content"/>
  </div>

    {#if !$isDrawerStatic && $isDrawerOpened}
      <div class="drawer-backdrop" style="opacity: {drawerTranslateLeft * 0.3}" on:click={close}/>
    {/if}
  <div class="drawer" class:closed={drawerTransition} style="width: {drawerWidth}px;left: {drawerWidth * (drawerTranslateLeft - 1)}px">
    <slot name="drawer"/>
  </div>
</div>

<style>
  .container {
    position: relative;
    height: 100%;
  }

  .container.static {
    display: flex;
    flex-direction: row-reverse;
  }

  .content {
    height: 100%;
  }

  .container.static .content {
    flex-grow: 1;
    flex-shrink: 1;
  }

  .drawer {
    position: absolute;
    top: 0;
    bottom: 0;
    overflow: hidden;
  }

  .static .drawer {
    position: static;
  }

  .drawer.closed {
    transition: left .2s;
  }

  .drawer-backdrop {
    background-color: black;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
</style>